import React, { Component } from 'react';
import './Button.css';
import { Link } from 'react-router';

class Button extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    static propTypes =  {
        values:     React.PropTypes.object,
        onClick:   React.PropTypes.func
    }

  render() {

    if (this.props.values === undefined || this.props.values.to === undefined) return null;

      const title = <span dangerouslySetInnerHTML={{__html: this.props.values.title}}></span>;

      return (
          <Link
              activeClassName="active"
              to={this.props.values.to.toString()}
              className={this.props.cssClass}
          >
              {title}
          </Link>
      );

  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.js